module.exports = __webpack_public_path__ + "static/media/sign_in_honey_combs.fd7b4b8d.svg";